<template>
  <div class="message-container">
    <el-dialog :title="'添加询盘'" :visible.sync="dialogFormVisible" width="40%">
      <el-form :model="formData" ref="messageForm" :rules="rules" style="width: 94%; " label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户姓名" prop="c_name">
              <el-input v-model="formData.c_name" size="small" :readonly="readonly" placeholder="请输入客户姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="c_email">
              <el-input v-model.trim="formData.c_email" size="small" placeholder="请输入邮箱" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="电话" prop="c_tel">
              <el-input v-model="formData.c_tel" size="small" placeholder="请输入电话" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="国家" prop="c_country">
              <el-input v-model="formData.c_country" size="small" placeholder="请输入国家" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="产品" prop="product">
              <el-input v-model="formData.product" size="small" placeholder="请输入产品" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="解决方案" prop="solution">
              <el-input v-model="formData.solution" size="small" placeholder="请输入解决方案" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="线索来源" prop="group_tag">
              <el-select v-model="formData.group_tag" placeholder="请选择" style="width: 100%">
                <el-option label="商务通" value="商务通"></el-option>
                <el-option label="邮件咨询" value="邮件咨询"></el-option>
                <el-option label="电话咨询" value="电话咨询"></el-option>
                <el-option label="展会资源" value="展会资源"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属人" prop="owner">
              <treeselect
                v-model="formData.owner"
                :multiple="true"
                :clearable="false"
                :normalizer="normalizer"
                :options="ownerOptions"
                @input="ownValidate"
                placeholder="请选择所属人"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="详细信息" prop="message">
          <el-input type="textarea" v-model="formData.message" placeholder="详细信息" rows="4" />
        </el-form-item>

        <el-form-item>
          <el-button size="small" @click="resetForm">取 消</el-button>
          <el-button size="small" type="primary" @click="submitForm('messageForm')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <detail-info :detailData="rowData" :show="dialogTableVisible" @refreshFetchData="fetchData" @refreshStatus="viewDetails" @close="dialogTableVisible = false"></detail-info>
    <div class="filter-container">
      <div class="filter-container-left">
        <el-input
          placeholder="按所属人查找"
          v-model="filters[4].value"
          prefix-icon="el-icon-search"
          size="small"
          clearable
          style="width: 160px;margin-right: 10px"
          class="filter-item"
          v-if="userinfo['uid'] === '1'"
        />
        <el-input
          placeholder="按域名查找"
          v-model="filters[1].value"
          prefix-icon="el-icon-search"
          size="small"
          clearable
          style="width: 160px;margin-right: 10px"
          class="filter-item"
        />
        <el-input
          placeholder="按邮箱查找"
          v-model="filters[0].value"
          prefix-icon="el-icon-search"
          size="small"
          clearable
          style="width: 160px;margin-right: 10px"
          class="filter-item"
        />
        <el-select clearable class="filter-item" size="small" placeholder="按状态过滤" style="width: 160px;" v-model="filters[2].value">
          <el-option label="有效" value="1" />
          <el-option label="重复" value="2" />
          <el-option label="无效" value="3" />
          <el-option label="未处理" value="0" />
        </el-select>
        <el-date-picker
          v-model="filters[3].value"
          type="daterange"
          align="right"
          size="small"
          unlink-panels
          value-format="timestamp"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          :picker-options="pickerOptions"
          @change="dateChange"
          style="margin-left: 10px"
        >
        </el-date-picker>
        <el-button class="filter-item" style="margin-left: 10px;" size="mini" type="primary" icon="el-icon-plus" @click="handleMessageAdd">新建询盘</el-button>
      </div>
    </div>
    <data-tables-server
      ref="multipleTable"
      :data="data"
      :total="total"
      :filters="filters"
      :table-props="tableProps"
      :loading="loading"
      :page-size="5"
      :pagination-props="{ background: true, pageSizes: [5, 10, 20] }"
      highlight-current-row
      layout="table,pagination"
      @query-change="fetchData"
      @row-dblclick="viewDetails"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" align="center" width="50"></el-table-column>
      <el-table-column prop="submited_time" label="询盘ID" sortable="custom">
        <template slot-scope="scope">
          <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom" show-overflow-tooltip />
      <el-table-column prop="submited_time" label="提交时间" sortable="custom" show-overflow-tooltip :formatter="formatDate" />
      <el-table-column label="询盘状态" align="center" min-width="60px" prop="state">
        <template slot-scope="scope">
          <el-tag :type="scope.row.c_state | stateFilter(scope.row.c_state)" size="small">{{ scope.row.c_state | stateShowFilter(scope.row.c_state) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="100px">
        <template slot-scope="scope">
          <el-button :size="btnsize" type="success" @click="handleCheck(scope.row)">详情</el-button>
          <el-button v-perm="['/inquiry/info/del']" :size="btnsize" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </data-tables-server>
    <div style="margin-top: -34px">
      <el-button type="danger" v-perm="['/inquiry/info/del']" :disabled="hiddenButton" icon="el-icon-delete" size="small" @click="deleteSelection()">删除选中行</el-button>
      <el-button type="primary" :disabled="hiddenButton" :loading="downLoading" icon="el-icon-download" size="small" @click="exportSelection()">导出选择项</el-button>
      <!-- <el-button
        type="primary"
        disabled
        icon="el-icon-circle-close"
        size="small"
        @click="setCurrent()"
      >标记为无效</el-button> -->
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import { DataTablesServer } from "vue-data-tables"
Vue.use(DataTablesServer)
//import perm权限
import perm from "@/directive/permission/index.js" // 权限判断指令

import DetailInfo from "@/views/Inquiry/Detail"
import clipboard from "@/directive/clipboard/index.js" // use clipboard by v-directive
// import the component
import Treeselect from "@riophae/vue-treeselect"
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css"

//import { getInquiryList, createInquiry, updateInquiry, deleteInquiry } from "@/api/inquiry"
import { getInquiryList, getOwnerOptions, createInquiry, deleteInquiry } from "@/api/inquiry"
export default {
  name: "Message",
  components: {
    DetailInfo,
    Treeselect
  },
  directives: {
    clipboard,
    perm
  },
  filters: {
    stateFilter(status) {
      const stateMap = {
        0: "",
        1: "success",
        2: "warning",
        3: "danger"
      }
      return stateMap[status]
    },
    stateShowFilter(status) {
      const stateShowMap = {
        0: "未处理",
        1: "有效",
        2: "重复",
        3: "无效"
      }
      return stateShowMap[status]
    }
  },
  data() {
    return {
      userinfo: {},
      ownerOptions: [],
      //自定义id,label
      normalizer(node) {
        return {
          id: node.uid,
          label: node.username
          //children: node.children
        }
      },
      currentPage: 1,
      pageSize: 5,
      currentLimit: 5,
      inline: false,
      readonly: false,
      dialogFormVisible: false,
      dialogTableVisible: false,
      operateType: "add",
      formData: {
        c_name: "",
        c_email: "",
        c_tel: "",
        c_country: "",
        product: "",
        solution: "",
        url: "",
        domain: "",
        tlds: "",
        device: "",
        ip: "",
        language: "",
        browser: "",
        owner: [],
        c_state: 0,
        operator: "",
        operate_time: "",
        submited_time: "",
        group_tag: "",
        message: ""
      },
      rules: {
        c_name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        c_email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        owner: [{ required: true, message: "请选择所属人", trigger: "input" }],
        group_tag: [{ required: true, message: "请选择来源", trigger: "change" }]
      },
      data: [],
      titles: [
        // {
        //   prop: "c_id",
        //   label: "询盘 ID"
        // },
        {
          prop: "c_name",
          label: "客户姓名"
        },
        {
          prop: "c_email",
          label: "客户邮箱"
        },
        {
          prop: "c_tel",
          label: "客户电话"
        },
        {
          prop: "c_country",
          label: "国家"
        },
        {
          prop: "product",
          label: "产品"
        }
        // {
        //   prop: "solution",
        //   label: "解决方案"
        // },
        // {
        //   prop: "state.state",
        //   label: "询盘状态"
        // },

        // {
        //   prop: "submit_time",
        //   label: "提交时间"
        // },
        // {
        //   prop: "device",
        //   label: "用户设备"
        // }
        // {
        //   prop: "refer",
        //   label: "来源"
        // }
        // {
        //   prop: "ip",
        //   label: "客户IP"
        // },
        // {
        //   prop: "language",
        //   label: "语种"
        // },
        // {
        //   prop: "operator",
        //   label: "处理人"
        // },
        // {
        //   prop: "operate_time",
        //   label: "处理时间"
        // },
        // {
        //   prop: "group_tag.tag",
        //   label: "分组"
        // },
        // {
        //   prop: "message",
        //   label: "留言内容"
        // }
      ],
      btnsize: "mini",
      tableProps: {
        border: true,
        stripe: true,
        highlightCurrentRow: true,
        defaultSort: {
          prop: "c_id",
          //order: "ascending"
          order: "descending"
        }
      },
      hiddenButton: true,
      selectedRows: [],
      rowData: {},
      downLoading: false,
      loading: false,
      selectedDate: "",
      total: 1,
      defaultQueryInfo: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const start = new Date(new Date()).getTime()
              const end = new Date(new Date()).getTime() + 24 * 60 * 60 * 1000 - 1
              //start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              //console.log(start, end)
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const start = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000)).getTime()
              const end = start + 24 * 60 * 60 * 1000 - 1
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: "最近7天",
            onClick(picker) {
              const start = new Date(new Date(new Date().getTime() - 24 * 7 * 60 * 60 * 1000)).getTime()
              const end = new Date(new Date()).getTime() + 24 * 60 * 60 * 1000 - 1
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: "最近30天",
            onClick(picker) {
              const start = new Date(new Date(new Date().getTime() - 24 * 30 * 60 * 60 * 1000)).getTime()
              const end = new Date(new Date()).getTime() + 24 * 60 * 60 * 1000 - 1
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: "当前月份",
            onClick(picker) {
              const now = new Date()
              var nowMonth = now.getMonth() //当前月
              var nowYear = now.getFullYear() //当前年
              //本月的开始时间
              var monthStartDate = new Date(new Date(nowYear, nowMonth, 1)).getTime()
              //本月的结束时间
              var monthEndDate = new Date(new Date(nowYear, nowMonth + 1, 0)).getTime() + 24 * 60 * 60 * 1000 - 1
              picker.$emit("pick", [monthStartDate, monthEndDate])
            }
          },
          {
            text: "上个月份",
            onClick(picker) {
              const now = new Date()
              var preMonth = now.getMonth() - 1 //上个月
              var nowYear = now.getFullYear() //当前年
              //上个月的开始时间
              var monthStartDate = new Date(new Date(nowYear, preMonth, 1)).getTime()
              //上个月的结束时间
              var monthEndDate = new Date(new Date(nowYear, preMonth + 1, 0)).getTime() + 24 * 60 * 60 * 1000 - 1
              picker.$emit("pick", [monthStartDate, monthEndDate])
            }
          }
        ]
      },
      filters: [
        {
          prop: "c_email",
          value: ""
        },
        {
          prop: "url",
          value: ""
        },
        {
          prop: "c_state",
          value: ""
        },
        {
          prop: "submited_time",
          value: ""
        },
        {
          prop: "the_owner",
          value: ""
        }
      ]
    }
  },
  created() {
    getOwnerOptions().then(res => {
      this.ownerOptions = res.data
      this.userinfo = JSON.parse(localStorage.getItem("user_info"))
      // this.ownerOptions = [
      //   {
      //     isDisabled: false,
      //     uid: 0,
      //     username: "公共询盘"
      //   }
      // ]
      //console.log(res.data)
    })
  },
  methods: {
    ownValidate() {
      if (this.formData.owner.length > 1) {
        this.formData.owner = []
      }
      this.$refs.messageForm.clearValidate()
    },
    dateChange(val) {
      if (val && val.length > 0) {
        //console.log(val)
        var startTime = parseInt(val.toString().split(",")[0] / 1000)
        var endTime = parseInt(val.toString().split(",")[1] / 1000)
        console.log(startTime, endTime)
      }
    },
    formatDate(row) {
      let date = new Date(parseInt(row.submited_time) * 1000)
      let Y = date.getFullYear() + "-"
      let M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) + "-" : date.getMonth() + 1 + "-"
      let D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " "
      let h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":"
      let m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":"
      let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    exportSelection() {
      if (this.selectedRows.length) {
        this.downLoading = true
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = ["客户姓名", "国家", "产品", "邮箱", "电话", "留言内容"]
          const filterVal = ["c_name", "c_country", "product", "c_email", "c_tel", "message"]
          const list = this.selectedRows
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "CMS"
          })
          setTimeout(() => {
            this.downLoading = false
            this.$refs.multipleTable.$refs.elTable.clearSelection()
          }, 800)
        })
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    viewDetails(row) {
      //console.log("我被调用了")
      //console.log(row)
      this.rowData = row
      this.dialogTableVisible = true
    },
    handleCheck(rowData) {
      //console.log(rowData)
      this.rowData = rowData
      this.dialogTableVisible = true
    },
    handleDelete(rowdata) {
      this.$confirm("此操作将永久删除此 [" + rowdata.group_tag + "] 信息， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          //json传到php转为关联数组
          const tempData = {
            inquiry_id: rowdata.c_id,
            group_tag: rowdata.group_tag
          }
          deleteInquiry(tempData).then(res => {
            if (res.type === "success") {
              this.fetchData()
            }
            this.$notify({
              message: res.message,
              type: res.type
            })
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          })
        })
    },
    deleteSelection() {
      if (this.selectedRows.length > 0) {
        this.$confirm("此操作将永久删除这些线索信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          console.log(this.selectedRows)
          let tempDataArray = []
          this.selectedRows.forEach(ele => {
            const tempData = {
              inquiry_id: ele["c_id"]
            }
            tempDataArray.push(tempData)
          })

          deleteInquiry(tempDataArray).then(res => {
            if (res.type === "success") {
              this.fetchData()
            }
            this.$notify({
              message: res.message,
              type: res.type
            })
          })
        })
      }
    },
    toggleSelection() {
      // console.log(rows)
      // if (rows) {
      //   rows.forEach(row => {
      //     this.$refs.multipleTable.toggleRowSelection(row)
      //   })
      // } else {
      //   this.$refs.multipleTable.clearSelection()
      // }
    },
    handleSelectionChange(val) {
      // console.log("hereaa")
      // //this.hiddenButton = !this.hiddenButton
      // if (this.selectedRows.length === 0) {
      //   this.hiddenButton = false
      // }
      // this.hiddenButton = true
      if (val.length > 0) {
        this.hiddenButton = false
        this.selectedRows = val
      } else {
        this.hiddenButton = true
      }
    },
    clipboardSuccess() {
      this.$message({
        message: "复制成功",
        type: "success",
        duration: 1500
      })
    },
    resetformData() {
      this.formData = {
        c_name: "",
        c_email: "",
        c_tel: "",
        c_country: "",
        product: "",
        solution: "",
        url: "",
        domain: "",
        tlds: "",
        browser: "",
        device: "",
        ip: "",
        language: "",
        owner: [],
        c_state: 0,
        operator: "",
        operate_time: "",
        submited_time: "",
        group_tag: "",
        message: ""
      }
    },
    handleMessageAdd() {
      //reset formData
      //console.log("i am here")
      //清除上一次add或者update的数据
      this.resetformData()
      this.operateType = "add"
      this.dialogFormVisible = true
      this.$nextTick(() => {
        //这里的回调函数在dom更新后调用
        //清除上一次的验证规则
        this.$refs.messageForm.clearValidate()
      })
    },
    fetchData(queryInfo) {
      if (!queryInfo) {
        queryInfo = this.defaultQueryInfo
      }
      if (queryInfo.type === "init") {
        this.defaultQueryInfo = queryInfo
      }
      this.loading = true
      this.currentPage = queryInfo.page
      this.pageSize = queryInfo.pageSize
      getInquiryList(queryInfo).then(res => {
        this.data = res.data.items
        this.total = res.data.total
        this.loading = false
      })
      //console.log(queryInfo)
      //this.currentPage = queryInfo.page
      //console.log(this.currentPage, queryInfo.page)
      //;(queryInfo.type === "page" || queryInfo.type === "size") && this.$message(`page: ${queryInfo.page}, pageSize: ${queryInfo.pageSize}`)
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.operateType === "add") {
            createInquiry(this.formData).then(res => {
              this.fetchData()
              this.dialogFormVisible = false
              this.$notify({
                type: res.type,
                message: res.message
              })
            })
          }
          //alert("good")
        } else {
          return false
        }
      })
    },
    resetForm() {
      //this.$refs[formName].resetFields()
      this.dialogFormVisible = false
    }
  }
}
</script>

<style lang="scss">
.message-container {
  margin-top: 30px;
  .filter-container {
    // border: 1px solid red;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
}
.pagination-wrap {
  margin-top: 30px;
  text-align: center;
}
.el-range-editor--small.el-input__inner {
  height: 31px;
}
.el-range-editor.el-input__inner {
  padding: 2px 10px;
}
.el-date-editor--daterange.el-input__inner {
  width: 220px;
}
.el-dialog__title {
  line-height: 24px;
  font-size: 16px;
  color: #303133;
}
</style>
